export default "__VITE_ASSET__C4i9onGz__"